import { IconicPencil } from '@insify/design-system/iconic-icons';
import { useTranslation } from 'react-i18next';

import { InfoDisplay } from '../../InfoDisplay';
import { Tabs } from '../../Tabs';
import { TypeformButton } from '../../TypeformButton/TypeformButton';
import styles from '../styles.module.css';

import type { OverviewData } from '../../../types/OverviewData';
import type { Bundle } from '../../../types/Policy';

interface Props {
  overview: OverviewData;
  bundle: Bundle;
}
export const PaymentsTab: React.FC<Props> = ({ overview, bundle }) => {
  const { t } = useTranslation('policy');

  if (!overview) {
    return null;
  }

  const availableAccounts = overview.personalInformation.bankAccounts;

  return (
    <Tabs.Panel id='payments'>
      <h2>{t('payment_preferences.title')}</h2>
      <p>{t('payment_preferences.subtitle')}</p>
      <InfoDisplay.Container>
        <InfoDisplay.Label>{t('payment_preferences.method.label')}</InfoDisplay.Label>
        <InfoDisplay.Text>{t('payment_preferences.direct_debit')}</InfoDisplay.Text>
      </InfoDisplay.Container>

      <InfoDisplay.Container>
        <InfoDisplay.Label>{t('payment_method.iban_label')}</InfoDisplay.Label>
        <InfoDisplay.Text data-hj-suppress subText={t('payment_method.iban_subtext')}>
          {availableAccounts && availableAccounts[0]}
        </InfoDisplay.Text>
      </InfoDisplay.Container>

      <TypeformButton
        type='button'
        trackingId='editPaymentMethod'
        formType='change_form'
        policyType={bundle.type}
        kind='neutral'
        label={t('edit')}
        hiddenFields={{
          email: overview?.personalInformation.email,
          policy_number: bundle.coverages[0].policyNumber,
          change_type: 'bank_account',
          country: bundle.country,
          name: bundle.type === 'company' ? bundle.companyName : overview?.personalInformation.name,
        }}
        leftIcon={<IconicPencil />}
        className={styles.editButton}
        confirmation={t('change_confirmation')}
      />
    </Tabs.Panel>
  );
};
